import { Endpoint } from "../Endpoint";
import API from "../API";

const name = "/deleteresponder";

interface PutRequestBody {
  id: string;
}

type PutResponseBody = "OK";

export {
  name,
  PutRequestBody,
  PutResponseBody,
};

export default class DeleteResponderEndpoint extends Endpoint {
  constructor(api: API, parent: Endpoint | null = null) {
    super(api, name, parent);
  }

  put(body: PutRequestBody) {
    return this.sendPut<PutResponseBody>(body);
  }
}
